import { useDataSubmit } from 'Simple/Data.js'
export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'task',
  })
  return function onClick() {
    submit({ type: 'generate_letter' })
  }
}
